export const hexToRgb = h => {
  let r = 0
  let g = 0
  let b = 0

  if (h.length === 4) {
    r = '0x' + h[1] + h[1]
    g = '0x' + h[2] + h[2]
    b = '0x' + h[3] + h[3]
  } else if (h.length === 7) {
    r = '0x' + h[1] + h[2]
    g = '0x' + h[3] + h[4]
    b = '0x' + h[5] + h[6]
  }
  return `${+r}, ${+g}, ${+b}`
}

export const generateRgbVar = (name, color) => {
  const colorRgb = hexToRgb(color)
  if (!colorRgb.includes('NaN')) {
    document.documentElement.style.setProperty(`--v-${name}-rgb`, colorRgb)
  }
}

export const createRgbVarsForThemes = theme => {
  Object.entries(theme).forEach(colors => {
    const key = colors[0]

    if (typeof colors[1] === 'object') {
      Object.entries(colors[1]).forEach(color => {
        const colorKey = color[0]
        generateRgbVar(`${key}-${colorKey}`, color[1])
      })
    } else {
      generateRgbVar(key, colors[1].toString())
    }
  })
}
